/**
 * REST client for the academy's INTERNAL catalog (plan 06 · E1, closes D2).
 *
 * Replaces PowerSync's `org_courses` stream, which hung off `member` without
 * filtering role or publication status: any member —including a student—
 * replicated offline the tree of ALL of the academy's courses, drafts
 * and deleted courses included. The server now decides what's visible
 * (`ManageAcademics` for drafts) and the student keeps offline the course
 * they're enrolled in (`my_enrolled_courses`/`my_cohort_courses` streams).
 *
 * The TYPE isn't hand-written: it comes from the OpenAPI generated from Rust
 * (`pnpm gen:api-types`) — data policy §4.2, "the type is shared, not
 * copied". Same cookie-BFF auth pattern as metrics/CRM/billing.
 */
import type { components } from "@space/client";
import { apiJson } from "@/lib/rest";

/** Internal catalog entry (== `core_rust::db::academy_catalog::OrgCourseEntry`). */
export type OrgCourseEntry = components["schemas"]["OrgCourseEntryDTO"];

const BASE = "/api/academy";

function orgUrl(orgId: string): string {
  return `${BASE}/${encodeURIComponent(orgId)}/courses`;
}

/**
 * The academy's internal catalog entries (no tree).
 *
 * The resource's other three endpoints —tree
 * (`GET …/courses/:courseId`), publish (`POST …/courses`) and unpublish
 * (`DELETE …/courses/:courseId`)— live on the server with their type already generated
 * in `@space/client`; they aren't wrapped here until they have a consumer: an
 * unused wrapper is dead code the exports guard won't forgive.
 */
export function fetchOrgCourses(orgId: string): Promise<OrgCourseEntry[]> {
  return apiJson<OrgCourseEntry[]>(orgUrl(orgId));
}
